import request from '@/common/js/request.js'
export function page(query) {
  return request({
    url: '/order/selectOrders',
    method: 'get',
    params: query
  })
}

//下订单
export function fetchoder(obj) {
  return request({
    url: '/order/pressOrder',
    method: 'post',
    data: obj
  })
}

//支付
export function fetchpressOrder(obj) {
  return request({
    url: '/order/third/pressOrder',
    method: 'post',
    data: obj
  })
}

// 手机支付
export function fetchpresswapOrder(obj) {
  return request({
    url: '/order/third/weiXinH5PressOrder',
    method: 'post',
    data: obj
  })
}

//删除订单
export function fetchdelOrder(id) {
  return request({
    url: '/order/deleteOrderByOrderNo/orderNo/' + id,
    method: 'put',
  })
}


//取消订单
export function fetchdelOrdercancel(id) {
  return request({
    url: '/order/cancelOrderByOrderNo/orderNo/' + id,
    method: 'put',
  })
}

// 获取订单详情
export function fetchdelOrderDetail(id) {
  let obj = {
    orderNo: id
  }
  return request({
    url: '/order/selectOneByOrderNo',
    method: 'get',
    params: obj
  })
}



// WEBPACK FOOTER //
// ./src/api/user-center/oder.js